import {gql} from '@apollo/client';
import {DeliveryTrackingLinkFragment} from '@src/__generated__/DeliveryTrackingLinkFragment';

export const showTrackingLink = (delivery?: DeliveryTrackingLinkFragment) => {
  const pickupAtTimestamp = delivery?.pickupAt ? new Date(delivery.pickupAt).getTime() : null;
  return !!(
    delivery?.hasTrackingInformation &&
    delivery?.tracking?.url &&
    pickupAtTimestamp &&
    Date.now() > pickupAtTimestamp - 15 * 60000
  );
};

export const deliveryTrackingLinkFragment = {
  delivery: gql`
    fragment DeliveryTrackingLinkFragment on DmDelivery {
      id
      pickupAt
      hasTrackingInformation
      tracking {
        url
      }
    }
  `,
};
